<template>
  <div class="interview">
    <div class="interview_record_container">
      <div class="interview_record_ship">
        <div class="interview_record_ship_search">
          <el-input
            size="mini"
            v-model="keyword"
            placeholder="请输入船名/MMSI/IMO/CN"
            @input="searchShips">
            <template slot="prepend">查船</template>
            <template slot="append" v-if="searching"><i class="el-icon-loading"></i></template>
          </el-input>
        </div>
        <div class="interview_record_ship_result" v-if="!searching && ships.length>0">
          <div class="interview_record_ship_result_one" v-for="s in ships" @click="getShip(s)">
            <el-row>
              <el-col :span="3">
                IMO:
              </el-col>
              <el-col :span="6">
                <span :style="`color:`+(s.imo != null && s.imo === keyword ? 'green' : 'black')+`;`">{{s.imo && s.imo>0 ? s.imo : '-'}}</span>
              </el-col>
              <el-col :span="3">
                船名
              </el-col>
              <el-col :span="12">
                <span :style="`color:`+(s.nameCn === keyword || s.name === keyword ? 'green' : 'black')+`;`">{{s.nameCn || s.name}}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3">
                MMSI:
              </el-col>
              <el-col :span="6">
                <span :style="`color:`+(s.mmsi === keyword ? 'green' : 'black')+`;`">{{s.mmsi && s.mmsi>0 ? s.mmsi : '-'}}</span>
              </el-col>
              <el-col :span="3">
                更新:
              </el-col>
              <el-col :span="12">
                <span :style="`color:`+(s.lasttime==null || s.lasttime < new Date().valueOf()/1000 - 86400 * 30 ? 'red' : (s.lasttime < new Date().valueOf()/1000 - 86400 * 7 ? 'blue' : 'green'))+`;`">{{s.lasttime!=null && s.lasttime>0 ? new Date(s.lasttime*1000).toLocaleString() : '-'}}</span>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="interview_record_ship_line">
          <div class="interview_record_ship_title">
            IMO:
          </div>
          <div class="interview_record_ship_value">
            {{ ship.imo ? ship.imo : '-' }}
          </div>
          <div class="interview_record_ship_title_right">
            船名:
          </div>
          <div class="interview_record_ship_value_right">
            {{ ship.shipname ? ship.shipname : '-' }}
          </div>
        </div>
        <div class="interview_record_ship_line">
          <div class="interview_record_ship_title">
            MMSI:
          </div>
          <div class="interview_record_ship_value">
            {{ ship.mmsi ? ship.mmsi : '-' }}
          </div>
          <div class="interview_record_ship_title_right">
            类型:
          </div>
          <div class="interview_record_ship_value_right">
            {{ ship.shipTypeOthers ? ship.shipTypeOthers : '-' }}
          </div>
        </div>
        <div class="interview_record_ship_line">
          <div class="interview_record_ship_title">
            检查地点:
          </div>
          <div class="interview_record_ship_value">
            <el-input size="mini" v-model="ship.check_place" maxlength="80" style="width:90%;"></el-input>
          </div>
          <div class="interview_record_ship_title">
            检查人员:
          </div>
          <div class="interview_record_ship_value">
            <el-input size="mini" v-model="ship.inspector" maxlength="80" style="width:90%;"></el-input>
          </div>
        </div>
        <div class="interview_record_ship_line">
          <div class="interview_record_ship_title_line">
            检查时间:
          </div>
          <div class="interview_record_ship_value_line">
            <el-date-picker
              style="width:96%;"
              v-model="ship.check_time"
              type="datetime"
              value-format="timestamp"
              size="mini"
              placeholder="选择日期时间">
            </el-date-picker>
          </div>
        </div>
        <div class="interview_record_ship_line">
          <div class="interview_record_ship_title_line">
            检查原因:
          </div>
          <div class="interview_record_ship_value_line">
            <el-input type="textarea" resize="none" :autosize="{ minRows:2, maxRows:2}" size="mini" placeholder="请填写项目检查内容" v-model="ship.check_reason" maxlength="500" style="width:96%;"></el-input>
          </div>
        </div>
      </div>
      <div class="interview_record_project" v-for="(project,index) in projects">
        <div class="interview_record_project_head">
          <div class="interview_record_project_head_title">
            项目 {{index+1}}
          </div>
          <div class="interview_record_project_head_close" @click="delProject(index)">
            X
          </div>
        </div>
        <div class="interview_record_project_info">
          <div class="interview_record_project_info_title">
            <div class="interview_record_project_info_title_top">
              检查内容:
            </div>
            <div class="interview_record_project_info_title_bottom">
              <!--
              <div class="interview_record_project_info_title_bottom_third">
                <i class="el-icon-microphone"></i>
              </div>
              <div class="interview_record_project_info_title_bottom_third">
                <i class="el-icon-video-play"></i>
              </div>
              <div class="interview_record_project_info_title_bottom_third">
                <i class="el-icon-delete"></i>
              </div>
              -->
            </div>
          </div>
          <div class="interview_record_project_info_value">
            <el-input type="textarea" resize="none" :autosize="{ minRows:2, maxRows:2}" size="mini" placeholder="请填写项目检查内容" v-model="project.check_content"/>
          </div>
        </div>
        <div class="interview_record_project_image">
          <div class="interview_record_project_image_head">
            <el-row v-if="browserType === 0">
              <el-col :span="6">
                项目照片:
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="primary" @click="openCamera(index)">拍照</el-button>
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="warning" @click="uploadImage(index)">上传</el-button>
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="danger" @click="clearImage(index)">清空</el-button>
              </el-col>
            </el-row>
            <el-row v-if="browserType !== 0">
              <el-col :span="8">
                项目照片:
              </el-col>
              <el-col :span="8">
                <el-button size="mini" type="warning" @click="uploadImage(index)">拍照/上传</el-button>
              </el-col>
              <el-col :span="8">
                <el-button size="mini" type="danger" @click="clearImage(index)">清空图片</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="interview_record_project_image_body" v-if="project.images.length>0">
            <div style="display:block;float:left;width:98%;height:20vh;border:1px solid rgba(150,150,150,0.1);">
              <el-image
                v-if="project.images"
                v-for="(image,index) in project.images"
                :key="index"
                style="width:28%;margin-left:4%;height:20vh;"
                :src="image.path"
                :preview-src-list="project.images.map(image => image.path)">
              </el-image>
            </div>
          </div>
        </div>
        <div class="interview_record_project_audio">
          <div class="interview_record_project_audio_head">
            <el-row>
              <el-col :span="6">
                项目录音:
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="primary" @click="openAudio(index)">录音</el-button>
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="warning" @click="uploadAudio(index)">上传</el-button>
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="danger" @click="clearAudio(index)">清空</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="interview_record_project_audio_body" v-if="project.audios.length>0">
            <div class="interview_record_project_audio_one" v-for="(audio,index) in project.audios" @click="playAudio(audio)">
              录音 {{index+1}}
            </div>
          </div>
        </div>
        <div class="interview_record_project_video">
          <div class="interview_record_project_video_head">
            <el-row v-if="browserType === 0">
              <el-col :span="6">
                项目视频:
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="primary" @click="openVideo(index)">录像</el-button>
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="warning" @click="uploadVideo(index)">上传</el-button>
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="danger" @click="clearVideo(index)">清空</el-button>
              </el-col>
            </el-row>
            <el-row v-if="browserType !== 0">
              <el-col :span="8">
                项目视频:
              </el-col>
              <el-col :span="8">
                <el-button size="mini" type="warning" @click="uploadVideo(index)">录像/上传</el-button>
              </el-col>
              <el-col :span="8">
                <el-button size="mini" type="danger" @click="clearVideo(index)">清空录像</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="interview_record_project_video_body" v-if="project.videos.length>0">
            <div class="interview_record_project_video_one" v-for="(video,index) in project.videos" @click="playVideo(video)">
              视频 {{index+1}}
            </div>
          </div>
        </div>
        <div class="interview_record_project_file">
          <div class="interview_record_project_file_head">
            <el-row>
              <el-col :span="8">
                项目文件:
              </el-col>
              <el-col :span="8">
                <el-button size="mini" type="warning" @click="uploadFile(index)">上传文件</el-button>
              </el-col>
              <el-col :span="8">
                <el-button size="mini" type="danger" @click="clearFile(index)">清空文件</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="interview_record_project_file_body" v-if="project.files.length>0">
            <div class="interview_record_project_file_one" v-for="(file,index) in project.files" @click="showFile(file)">
              文件 {{index+1}}
            </div>
          </div>
        </div>
      </div>
      <div class="interview_record_project_add" @click="addProject">
        <i class="el-icon-plus"></i>
      </div>
      <div class="interview_record_project_submit">
        <el-row>
          <el-col :span="12">
            <el-button size="mini" type="warning" @click="clearProject">清空</el-button>
          </el-col>
          <el-col :span="12">
            <el-button size="mini" type="primary" @click="submitProject">提交</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <Audior ref="audior" @audioResult="audioResult"></Audior>
    <Videor ref="videor" @videoResult="videoResult"></Videor>
    <Camera ref="camerar" @cameraResult="cameraResult"></Camera>
    <Uploader ref="uploader" @uploaderResult="uploaderResult"></Uploader>
    <el-dialog
      title="播放录音"
      :showClose="false"
      :visible.sync="audioDialogVisible"
      :fullscreen="true"
      width="100%"
      center>
      <div style="float:left;width:100%;text-align:center;" v-if="audio!=null">
        <audio ref="audioPlayer" controls preload="none" loop autoplay style="width:100%;">
          <source :src="audio.path" :type="audio.type"/>
        </audio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeAudioDialog">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="播放视频"
      :visible.sync="videoDialogVisible"
      :fullscreen="true"
      :showClose="false"
      width="100%"
      center>
      <div style="float:left;width:100%;text-align:center;" v-if="video!=null">
        <video ref="videoPlayer" controls preload="none" loop autoplay style="width:100%;">
          <source :src="video.path" :type="video.type"/>
        </video>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeVideoDialog">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="文件属性"
      :visible.sync="fileDialogVisible"
      :fullscreen="true"
      :showClose="false"
      width="100%"
      center>
      <div style="float:left;width:100%;text-align:left;" v-if="file!=null">
        <el-row>
          <el-col :span="6">
            文件名:
          </el-col>
          <el-col :span="18">
            {{file.filename}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            后缀:
          </el-col>
          <el-col :span="9">
            {{file.ext}}
          </el-col>
          <el-col :span="3">
            类型:
          </el-col>
          <el-col :span="9">
            {{file.type}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            文件地址:
          </el-col>
          <el-col :span="18">
            {{file.path}}
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeFileDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { searchShips,interviewRecordGet,interviewRecordUpdate } from '../../api/api';
  import Audior from '../audior'
  import Videor from '../videor';
  import Camera from '../camera';
  import Uploader from '../uploader';
  import { getJsonStorage } from "../../util/storage";
  import { getBrowserType } from "../../util/common"

  export default {
    name: "InterviewRecord",
    components:{
      Audior,
      Videor,
      Camera,
      Uploader
    },
    data() {
      return {
        id: this.$route.query.id,
        keyword:null,
        ship:{shipname:null,mmsi:null,imo:null,check_time:new Date().valueOf(),inspector:null,check_reason:null,check_place:null},
        projects:[],
        uploadType:-1,
        projectIndex:-1,
        ships:[],
        searching:false,
        inputSwitch:null,
        audio:null,
        video:null,
        file:null,
        audioDialogVisible:false,
        videoDialogVisible:false,
        fileDialogVisible:false,
        browserType: getBrowserType(),
        user:getJsonStorage('openai_user'),
        privileges:getJsonStorage('openai_privileges')
      }
    },
    mounted(){
      if(this.id && this.id!==''){
        interviewRecordGet(this.id).then(res => {
          if(res && res.status === 0){
            this.projects = JSON.parse(res.data.projects);
            let ship = JSON.parse(JSON.stringify(res.data));
            delete ship['projects'];
            ship['check_time'] = ship['check_time']!=null ? ship['check_time']*1000 : null;
            this.ship = ship;
          }
        });
      }
    },
    methods:{
      searchShips(){
        if(this.inputSwitch!=null){
          clearTimeout(this.inputSwitch);
          this.ships = [];
        }
        if(this.keyword != null && this.keyword !== ''){
          if(this.keyword.length<3){
            this.searching = false;
            return;
          }
          this.searching = true;
          this.inputSwitch = setTimeout(()=>{
            this.keyword = this.keyword.toUpperCase();
            searchShips(this.keyword).then(res => {
              if(res && res.status === 0){
                this.ships = res.data;
                this.searching = false;
              }
            });
          },800);
        }else{
          this.searching = false;
        }
      },
      getShip(ship){
        this.ship['shipname'] = ship['nameCn'] || ship['name'];
        this.ship['imo'] = ship['imo'] && ship['imo'] > 0 ? ship['imo'] : null;
        this.ship['mmsi'] = ship['mmsi'];
        this.ship['shipTypeOthers'] = ship['shipTypeOthers'];
        this.ships = [];
        this.keyword = null;
      },
      addProject(){
        this.projects.push({content:null,record:null,images:[],videos:[],audios:[],files:[]});
      },
      delProject(index){
        this.$confirm('确认删除项目'+(index+1)+'所有内容?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center:true
        }).then(() => {
          this.projects.splice(index,1);
        }).catch(() => {});
      },
      clearProject(){
        this.$confirm('确认清空项目所有内容?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center:true
        }).then(() => {
          this.ship = {check_time:new Date().valueOf(),inspector:null,check_reason:null,check_place:null,shipname:null,imo:null};
          this.projects = [];
        }).catch(() => {});
      },
      submitProject(){
        let params = JSON.parse(JSON.stringify(this.ship));
        params['check_time'] = Math.floor(params['check_time']/1000);
        params['projects'] = JSON.stringify(this.projects);
        if(this.id && this.id !== '') params['id'] = this.id;
        interviewRecordUpdate(params).then(res => {
          if(res && res.status===0){
            this.$confirm('提交保存成功,是否跳转列表页?','提示',{
              center:true,
              distinguishCancelAndClose: true,
              confirmButtonText: '确定',
              cancelButtonText: '不跳转',
              callback: action => {
                if(action === 'confirm'){
                  this.$router.push('/interview/list');
                }
              }
            });
          }
        });
      },
      clearImage(index){
        this.$confirm('确认清空该项目图片?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center:true
        }).then(() => {
          this.projects[index]['images'] = [];
        }).catch(() => {});
      },
      clearAudio(index){
        this.$confirm('确认清空该项目录音?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center:true
        }).then(() => {
          this.projects[index]['audios'] = [];
        }).catch(() => {});
      },
      clearVideo(index){
        this.$confirm('确认清空该项目录像?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center:true
        }).then(() => {
          this.projects[index]['videos'] = [];
        }).catch(() => {});
      },
      clearFile(index){
        this.$confirm('确认清空该项目文件?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center:true
        }).then(() => {
          this.projects[index]['files'] = [];
        }).catch(() => {});
      },
      audioResult(result){
        this.projects[this.projectIndex]['audios'].push(result);
      },
      videoResult(result){
        this.projects[this.projectIndex]['videos'].push(result);
      },
      cameraResult(result){
        this.projects[this.projectIndex]['images'].push(result);
      },
      uploadImage(index){
        this.uploadType = 1;
        this.projectIndex = index;
        this.$refs.uploader.openUploader('image/*');
      },
      uploadVideo(index){
        this.uploadType = 2;
        this.projectIndex = index;
        this.$refs.uploader.openUploader('video/*');
      },
      uploadAudio(index){
        this.uploadType = 3;
        this.projectIndex = index;
        this.$refs.uploader.openUploader('audio/*');
      },
      uploadFile(index){
        this.uploadType = 4;
        this.projectIndex = index;
        this.$refs.uploader.openUploader('*/*');
      },
      uploaderResult(result){
        switch(this.uploadType){
          case 1:
            this.projects[this.projectIndex]['images'] = this.projects[this.projectIndex]['images'].concat(result['images']);
            break;
          case 2:
            this.projects[this.projectIndex]['videos'] = this.projects[this.projectIndex]['videos'].concat(result['videos']);
            break;
          case 3:
            this.projects[this.projectIndex]['audios'] = this.projects[this.projectIndex]['audios'].concat(result['audios']);
            break;
          case 4:
            this.projects[this.projectIndex]['files'] = this.projects[this.projectIndex]['files'].concat(result['files']);
            break;
          default:
            break;
        }
      },
      openAudio(index){
        this.projectIndex = index;
        this.$refs.audior.openAudior();
      },
      openVideo(index){
        this.projectIndex = index;
        this.$refs.videor.openVideor();
      },
      openCamera(index){
        this.projectIndex = index;
        this.$refs.camerar.openCamera();
      },
      playAudio(audio){
        this.audio = audio;
        this.audioDialogVisible = true;
      },
      playVideo(video){
        this.video = video;
        this.videoDialogVisible = true;
      },
      showFile(file){
        this.file = file;
        this.fileDialogVisible = true;
      },
      closeAudioDialog(){
        this.$refs.audioPlayer.pause();
        this.audioDialogVisible = false;
        this.audio = null;
      },
      closeVideoDialog(){
        this.$refs.videoPlayer.pause();
        this.videoDialogVisible = false;
        this.video = null;
      },
      closeFileDialog(){
        this.fileDialogVisible = false;
        this.file = null;
      }
    }
  }
</script>

<style scoped>
  .interview {
    position:absolute;
    top:6vh;
    left:0;
    width: 100%;
    height: 94vh;
    background-color: #f7f7f7;
    text-shadow: .5px .3px .5px grey;
  }

  .interview_record_container {
    width:100%;
    float:left;
    height:92vh;
    overflow-y: scroll;
    overflow-x: inherit;
  }
  .interview_record_ship {
    float:left;
    width:90%;
    height:38vh;
    margin: 1vh 3%;
    padding: 1vh 2%;
    border:0.2vh solid rgba(100,100,100,0.1);
  }
  .interview_record_ship_search {
    float:left;
    width:100%;
    height:5vh;
  }
  .interview_record_ship_line {
    float:left;
    width:100%;
    height:4vh;
    line-height:4vh;
    margin:1vh 0;
    font-size: .75rem;
  }
  .interview_record_ship_title {
    float:left;
    width:18%;
    text-align:left;
    color:grey;
  }
  .interview_record_ship_value {
    float:left;
    width:32%;
    height:5vh;
    text-align:left;
    overflow: hidden;
  }
  .interview_record_ship_title_right {
    float:left;
    width:12%;
    text-align:left;
    color:grey;
  }
  .interview_record_ship_value_right {
    float:left;
    width:38%;
    height:5vh;
    text-align:left;
  }
  .interview_record_ship_title_line {
    float:left;
    width:18%;
    text-align:left;
    color:grey;
  }
  .interview_record_ship_value_line {
    float:left;
    width:82%;
    text-align:left;
  }
  .interview_record_project {
    float:left;
    width:90%;
    margin:1vh 3%;
    border:.1vh solid rgba(100,100,100,0.1);
    border-radius:1vh;
    padding:1vh 2%;
    font-size:.75rem;
    color:grey;
  }
  .interview_record_project_add {
    float:left;
    width:92%;
    height:10vh;
    line-height:10vh;
    margin:1vh 4%;
    border: .2vh solid rgba(100,100,100,0.2);
    border-radius:1vh;
    text-align:center;
    font-size:6vh;
    font-weight:bold;
    color:rgba(150,150,150,0.3);
    background-color:rgba(180,180,180,0.1);
  }
  .interview_record_project_submit {
    float:left;
    width:92%;
    height:5vh;
    line-height:5vh;
    margin: 1vh 4%;
    text-align:center;
  }
  .interview_record_project_head {
    float:left;
    width:100%;
    height:5vh;
    line-height:5vh;
    border-bottom:.2vh solid rgba(100,100,100,0.2);
  }
  .interview_record_project_head_title {
    float:left;
    width:92%;
    height:3vh;
    line-height:3vh;
    text-align:left;
  }
  .interview_record_project_head_close {
    float:left;
    width:8%;
    height:3vh;
    line-height:3vh;
    text-align:center;
    cursor:pointer;
  }
  .interview_record_project_info {
    float:left;
    width:100%;
    height:7vh;
    padding:1vh 0;
  }
  .interview_record_project_info_title {
    float:left;
    width:25%;
    height:5vh;
    line-height:5vh;
  }
  .interview_record_project_info_title_top {
    width:100%;
    float:left;
    height:3.5vh;
    line-height:3.5vh;
  }
  .interview_record_project_info_title_bottom {
    width:100%;
    float:left;
    height:3.5vh;
    line-height:3.5vh;
  }
  .interview_record_project_info_value {
    float:left;
    width:75%;
    height:5vh;
    line-height:5vh;
  }
  .interview_record_project_image {
    float:left;
    width:100%;
    padding:1vh 0;
    border-top: .2vh solid rgba(100,100,100,0.2);
  }
  .interview_record_project_image_head {
    float:left;
    width:100%;
    height:5vh;
    line-height:5vh;
    text-align:left;
  }
  .interview_record_ship_result {
    position:absolute;
    top:9vh;
    left:0;
    width:90%;
    margin: 0 5%;
    background-color: white;
    max-height:50vh;
    overflow-y:scroll;
    border:.2vh solid rgba(150,150,150,0.2);
    border-radius:1vh;
    z-index:99;
  }
  .interview_record_ship_result_one {
    width:96%;
    float:left;
    padding: 1vh 2%;
    font-size:.8rem;
    border-bottom: .2vh solid rgba(150,150,150,0.1);
    cursor:pointer;
  }
  .interview_record_project_audio {
    float:left;
    width:100%;
    padding:1vh 0;
    border-top: .2vh solid rgba(100,100,100,0.2);
  }
  .interview_record_project_audio_head {
    float:left;
    width:100%;
    height:5vh;
    line-height:5vh;
    text-align:left;
  }
  .interview_record_project_audio_one {
    float:left;
    width:20%;
    height:10vh;
    line-height:10vh;
    border:.2vh solid rgba(150,150,150,0.3);
    margin:1vh 0 0 4%;
    text-align:center;
    cursor:pointer;
  }
  .interview_record_project_video {
    float:left;
    width:100%;
    padding:1vh 0;
    border-top: .2vh solid rgba(100,100,100,0.2);
  }
  .interview_record_project_video_head {
    float:left;
    width:100%;
    height:5vh;
    line-height:5vh;
    text-align:left;
  }
  .interview_record_project_video_one {
    float:left;
    width:20%;
    height:10vh;
    line-height:10vh;
    border:.2vh solid rgba(150,150,150,0.3);
    margin:1vh 0 0 4%;
    text-align:center;
    cursor:pointer;
  }
  .interview_record_project_file {
    float:left;
    width:100%;
    padding:1vh 0;
    border-top: .2vh solid rgba(100,100,100,0.2);
  }
  .interview_record_project_file_head {
    float:left;
    width:100%;
    height:5vh;
    line-height:5vh;
    text-align:left;
  }
  .interview_record_project_file_one {
    float:left;
    width:20%;
    height:10vh;
    line-height:10vh;
    border:.2vh solid rgba(150,150,150,0.3);
    margin:1vh 0 0 4%;
    text-align:center;
    cursor:pointer;
  }
  .dialog-footer {
    position:absolute;
    bottom:2vh;
    left:0;
    width:100%;
    text-align:center;
  }
  .interview_record_project_info_title_bottom_third {
    width:20%;
    margin: 0 4%;
    height:3vh;
    line-height:3vh;
    text-align:center;
    float:left;
  }
</style>



// WEBPACK FOOTER //
// src/components/interview/record.vue